// Recovered compiled webpack factory 71124. Edit this function expression; run npm run build.
(e, t) => {
  function r(e) {
    var t;
    let { config: r, src: n, width: i, quality: o } = e,
      a =
        o ||
        (null == (t = r.qualities)
          ? void 0
          : t.reduce((e, t) => (Math.abs(t - 75) < Math.abs(e - 75) ? t : e))) ||
        75;
    return (
      r.path +
      "?url=" +
      encodeURIComponent(n) +
      "&w=" +
      i +
      "&q=" +
      a +
      (n.startsWith("/_next/static/media/") && 1 ? "&dpl=dpl_6RLyVc3L2qK5GpvsjXmfExxYVxRH" : "")
    );
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    (r.__next_img_default = !0));
  let n = r;
}
